import * as types from './types';
import { loading } from 'State/actions';

export const getData = ({ site, fromDate, toDate, isSupper }) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.MODIFY_DAILY_DEPOSIT_FETCHING_TABLE_DATA, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `DailyDeposit/GetDailyDeposits`,
        {
          SiteId: site === 'ALL' ? '' : site,
          FromDate: fromDate,
          ToDate: toDate,
          IsSupper: isSupper,
        }
      );
      dispatch({
        type: types.MODIFY_DAILY_DEPOSIT_GET_DATA,
        payload: response.data.Data,
      });
    } catch (error) {
      dispatch({
        type: types.MODIFY_DAILY_DEPOSIT_FETCH_ERROR,
        payload: error.response.data.Data,
      });
    }

    dispatch(loading(types.MODIFY_DAILY_DEPOSIT_FETCHING_TABLE_DATA, false));
  };
};

export const deleteDailyDeposit = (
  dailyDepositId,
  siteId,
  fromDate,
  toDate,
  isSupper
) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.MODIFY_DAILY_DEPOSIT_FETCHING, true));
    try {
      await MPWWebApi.postGenericInsertUpdate(
        `DailyDeposit/DeleteDailyDeposit`,
        {
          dailyDepositId,
          siteId,
          isSupper,
        }
      );

      dispatch({ type: types.MODIFY_DAILY_DEPOSIT_DELETED, payload: true });

      const site = getState().ModifyDailyDepositState.ModifyDailyDepositGrid
        .site;
      dispatch(getData({ site, fromDate, toDate, isSupper }));
    } catch (error) {
      dispatch({
        type: types.MODIFY_DAILY_DEPOSIT_FETCH_ERROR,
        payload: error.response.data.Data,
      });
    }
    dispatch(loading(types.MODIFY_DAILY_DEPOSIT_FETCHING, false));
  };
};

export const clearDeleted = () => {
  return {
    type: types.MODIFY_DAILY_DEPOSIT_DELETED,
    payload: false,
  };
};

export const setExists = ({ site, fromDate, toDate, isSupper }) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.MODIFY_DAILY_DEPOSIT_FETCHING_TABLE_DATA, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `DailyDeposit/GetDailyDeposits`,
        {
          SiteId: site,
          FromDate: fromDate,
          ToDate: toDate,
          IsSupper: isSupper,
        }
      );
      dispatch({
        type: types.MODIFY_DAILY_DEPOSIT_EXISTS,
        payload: response.data.Data.length > 0 ? true : false,
      });
    } catch (error) {
      dispatch({
        type: types.MODIFY_DAILY_DEPOSIT_FETCH_ERROR,
        payload: error.response.data.Data,
      });
    }

    dispatch(loading(types.MODIFY_DAILY_DEPOSIT_FETCHING_TABLE_DATA, false));
  };
};

export const clearExists = () => {
  return {
    type: types.MODIFY_DAILY_DEPOSIT_EXISTS,
    payload: false,
  };
};

export const setFilterField = (type, value) => {
  return {
    type,
    payload: value,
  };
};



// WEBPACK FOOTER //
// ./src/pages/modifydailydeposits/state/modifydailydepositgrid/actions.js